import styled from "styled-components";

export const StyleDiv = styled.div`
  display: ${(props) => props.display};
  grid-template-columns: ${(props) => props.gridTemplateColumns};
  flex: ${(props) => props.flex};
  flex-direction: ${(props) => props.flexDirection};
  flex-shrink: ${(props) => props.flexShrink};
  flex-wrap: ${(props) => props.flexWrap};
  align-items: ${(props) => props.alignItems};
  align-content: ${(props) => props.alignContent};
  justify-content: ${(props) => props.justifyContent};
  float: ${(props) => props.float};
  position: ${(props) => props.position};
  top: ${(props) => props.top};
  right: ${(props) => props.right};
  bottom: ${(props) => props.bottom};
  left: ${(props) => props.left};
  margin: ${(props) => props.margin};
  margin-right: ${(props) => props.marginRight};
  margin-left: ${(props) => props.marginLeft};
  margin-top: ${(props) => props.marginTop};
  margin-bottom: ${(props) => props.marginBottom};
  padding: ${(props) => props.padding};
  min-width: ${(props) => props.minWidth};
  width: ${(props) => props.width};
  max-width: ${(props) => props.maxWidth};
  min-height: ${(props) => props.minHeight};
  height: ${(props) => props.height};
  max-height: ${(props) => props.maxHeight};
  background: ${(props) => props.background};
  border: ${(props) => props.border};
  border-bottom: ${(props) => props.borderBottom};
  border-radius: ${(props) => props.borderRadius};
  background-color: ${(props) => props.backgroundColor};
  text-align: ${(props) => props.textAlign};
  font-size: ${(props) => props.fontSize};
  font-weight: ${(props) => props.fontWeight || "normal"};
  overflow: ${(props) => props.overflow};
  overflow-x: ${(props) => props.overflowX};
  overflow-y: ${(props) => props.overflowY};
  box-shadow: ${(props) => props.boxShadow};
  box-sizing: ${(props) => props.boxSizing};
  transition: ${(props) => props.transition};
  z-index: ${(props) => props.zIndex};
  opacity: ${(props) => props.opacity};
  transform: ${(props) => props.transform};
  visibility: ${(props) => props.visibility};
  transition: ${(props) => props.transition};
  color: ${(props) => props.color};
  title: ${(props) => props.title};
  vertical-align: ${(props) => props.verticalAlign};
  text-align: ${(props) => props.textAlign};
  grid-area: ${(props) => props.gridArea};
  box-shadow: ${(props) => props.boxShadow};
  gap: ${(props) => props.gap};
  & *:hover {
    cursor: ${(props) => props.cursor};
  }
  &::-webkit-scrollbar {
    width: 0px;
  }
`;

export const StyleDivWithGap = styled.div`
  display: ${(props) => props.display};
  grid-template-columns: ${(props) => props.gridTemplateColumns};
  flex: ${(props) => props.flex};
  flex-direction: ${(props) => props.flexDirection};
  flex-shrink: ${(props) => props.flexShrink};
  flex-wrap: ${(props) => props.flexWrap};
  align-items: ${(props) => props.alignItems};
  align-content: ${(props) => props.alignContent};
  justify-content: ${(props) => props.justifyContent};
  gap: ${(props) => props.gap};
  row-gap: ${(props) => props.rowGap};
  float: ${(props) => props.float};
  position: ${(props) => props.position};
  top: ${(props) => props.top};
  right: ${(props) => props.right};
  bottom: ${(props) => props.bottom};
  left: ${(props) => props.left};
  margin: ${(props) => props.margin};
  margin-right: ${(props) => props.marginRight};
  margin-left: ${(props) => props.marginLeft};
  margin-top: ${(props) => props.marginTop};
  margin-bottom: ${(props) => props.marginBottom};
  padding: ${(props) => props.padding};
  min-width: ${(props) => props.minWidth};
  width: ${(props) => props.width};
  max-width: ${(props) => props.maxWidth};
  min-height: ${(props) => props.minHeight};
  height: ${(props) => props.height};
  max-height: ${(props) => props.maxHeight};
  background: ${(props) => props.background};
  border: ${(props) => props.border};
  border-bottom: ${(props) => props.borderBottom};
  border-radius: ${(props) => props.borderRadius};
  background-color: ${(props) => props.backgroundColor};
  text-align: ${(props) => props.textAlign};
  font-size: ${(props) => props.fontSize};
  font-weight: ${(props) => props.fontWeight || "normal"};
  overflow: ${(props) => props.overflow};
  overflow-x: ${(props) => props.overflowX};
  overflow-y: ${(props) => props.overflowY};
  box-shadow: ${(props) => props.boxShadow};
  box-sizing: ${(props) => props.boxSizing};
  transition: ${(props) => props.transition};
  z-index: ${(props) => props.zIndex};
  opacity: ${(props) => props.opacity};
  transform: ${(props) => props.transform};
  visibility: ${(props) => props.visibility};
  transition: ${(props) => props.transition};
  color: ${(props) => props.color};
  title: ${(props) => props.title};
  vertical-align: ${(props) => props.verticalAlign};
  text-align: ${(props) => props.textAlign};
  grid-area: ${(props) => props.gridArea};
  box-shadow: ${(props) => props.boxShadow};
  & *:hover {
    cursor: ${(props) => props.cursor};
  }
  &::-webkit-scrollbar {
    width: 0px;
  }
`;

export const StyleDivCenterChild = styled(StyleDiv)`
  display: flex;
  flex-direction: ${(props) => props.flexDirection || "column"};
  border: ${(props) => props.border || "inherit"};
  align-items: ${(props) => props.alignItems || "center"};
  justify-content: center;
  overflow: ${(props) => props.overflow || "inherit"};
  margin-top: ${(props) => props.marginTop};
  margin-bottom: ${(props) => props.marginBottom};
  margin-left: ${(props) => props.marginLeft};
  margin-right: ${(props) => props.marginRight};
  width: ${(props) => props.width};
`;

export const StyleDivLeadingChild = styled(StyleDiv)`
  display: flex;
  flex-direction: ${(props) => props.flexDirection || "column"};
  border: ${(props) => props.border || "inherit"};
  align-items: ${(props) => props.alignItems || "left"};
  justify-content: left;
  overflow: ${(props) => props.overflow || "inherit"};
`;

export const StyleDivSmallFont = styled(StyleDiv)`
  font-size: ${(props) => "0.8rem"};
`;
